import { render, staticRenderFns } from "./VideoRecordPage.vue?vue&type=template&id=b7ae5d20&scoped=true"
import script from "./VideoRecordPage.vue?vue&type=script&lang=js"
export * from "./VideoRecordPage.vue?vue&type=script&lang=js"
import style0 from "./VideoRecordPage.vue?vue&type=style&index=0&id=b7ae5d20&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ae5d20",
  null
  
)

export default component.exports